import { gql } from '@apollo/client'

export const OPERATION_FIND_SITE_UNSCOPED = gql`
  query FindSiteUnscoped($id: ID!) {
    site: findSiteUnscopedById(id: $id) {
      id
      sf_id
      name
      state
      has_active_project
      has_process
      visibility_in_center
      address {
        city
        zipcode
        street_name
        street_number
      }
      location {
        latitude
        longitude
      }
    }
  }
`

export const OPERATION_SEARCH_SITES_UNSCOPED = gql`
  query SearchSitesUnscoped(
    $verbatim: String
    $state: [String]
    $has_active_project: Boolean
    $has_process: Boolean
    $visibility_in_center: String
    $sf_parent_id: String
    $offset: Int
    $limit: Int
    $sort_by: String
    $sort_direction: String
  ) {
    sites: searchSitesUnscoped(
      verbatim: $verbatim
      state: $state
      has_active_project: $has_active_project
      has_process: $has_process
      visibility_in_center: $visibility_in_center
      sf_parent_id: $sf_parent_id
      offset: $offset
      limit: $limit
      sort_by: $sort_by
      sort_direction: $sort_direction
    ) {
      id
      sf_id
      name
      state
      has_active_project
      has_process
      visibility_in_center
      account_parent_name
    }
  }
`

export const OPERATION_COUNT_SITES_UNSCOPED = gql`
  query CountSitesUnscoped(
    $verbatim: String
    $state: [String]
    $has_active_project: Boolean
    $has_process: Boolean
    $visibility_in_center: String
    $sf_parent_id: String
  ) {
    count: countSitesUnscoped(
      verbatim: $verbatim
      state: $state
      has_active_project: $has_active_project
      has_process: $has_process
      visibility_in_center: $visibility_in_center
      sf_parent_id: $sf_parent_id
    )
  }
`

export const OPERATION_SEARCH_ACCOUNTS_UNSCOPED = gql`
  query AccountsUnscopedByName($name: String!) {
    accounts: accountsUnscopedByName(name: $name) {
      id
      sf_id
      name
      highlight_name
    }
  }
`

export const OPERATION_AGG_SITES_UNSCOPED_STATES = gql`
  query AggSitesUnscopedStates(
    $verbatim: String
    $has_active_project: Boolean
    $has_process: Boolean
    $visibility_in_center: String
  ) {
    states: aggSitesUnscopedStates(
      verbatim: $verbatim
      has_active_project: $has_active_project
      has_process: $has_process
      visibility_in_center: $visibility_in_center
    ) {
      key
      count
    }
  }
`
